function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3a363d;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "rect3687",
  className: "cls-1",
  d: "M24.53.61a24,24,0,0,0-24,24V59.37a24,24,0,0,0,24,24H59.47a24,24,0,0,0,24-24V24.63a24,24,0,0,0-24-24Zm0,7.12H59.47a16.79,16.79,0,0,1,16.91,16.9V59.37a16.79,16.79,0,0,1-16.91,16.9H24.53A16.79,16.79,0,0,1,7.62,59.37V24.63A16.79,16.79,0,0,1,24.53,7.73Zm39.74,7.11a5,5,0,1,0,5,5A5,5,0,0,0,64.27,14.84ZM42,20.69A21.31,21.31,0,1,0,63.32,42,21.36,21.36,0,0,0,42,20.69Zm0,7.11A14.2,14.2,0,1,1,27.8,42,14.15,14.15,0,0,1,42,27.8Z"
});

var SvgIgicon = function SvgIgicon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 84 84",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIgicon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/igicon.75dcf056.svg";
export { ForwardRef as ReactComponent };